// whats going on here?
// eslint-disable-next-line no-unused-vars
/* global dataLayer, _cc10461, Sailthru */

import { GTM_EVENTS } from "config/constants";
let landingStreamInfo;

export function setPageTitleInDataLayer() {
  if (document.title.indexOf(" - Axios") > 0) {
    const slicedTitle = document.title.slice(
      0,
      document.title.indexOf(" - Axios")
    );
    dataLayer.push({ title: slicedTitle });
  }
}

export function setUserInDataLayer(id, isLoggedIn) {
  dataLayer.push({
    "userID Data Layer Var": id,
    "User Logged In": isLoggedIn,
  });
}

export function trackPageView() {
  dataLayer.push({
    ...resetContentValues(),
    ...resetStreamValues(),
    Card: false,
    "Card Count": "",
    "Post ID": "",
    "event category": "",
    event: GTM_EVENTS.PAGE_VIEW,
  });
}

export function resetContentValues() {
  return {
    Headline: "",
    Authors: "",
    Editors: "",
    "Published Date": "",
    "Primary Section": "",
    Sections: "",
    "Primary Tag": "",
    Tags: "",
    Permalink: "",
    Rubric: "",
    Featured: "",
    Position: "",
    "Word Count Total": "",
    "Word Count Above Fold": "",
    "Word Count Below Fold": "",
    "Card Type": "",
    "Contains CTA": "",
    ...resetPromoValues(),
  };
}

export function resetPromoValues() {
  return {
    "Promo Header": "",
    "Promo Image": "",
    "Promo Title": "",
    "Promo Content": "",
    "Promo Link": "",
    "Promo List": "",
    "Promo ID": "",
  };
}

export function resetStreamValues() {
  return {
    "Stream Lookup": "",
    "Stream Type": "",
    "Stream Display Name": "",
    "Stream Query Param Override": "",
    "Stream After Permalink": "",
    "Stream Type After Permalink": "",
  };
}

export function setDataLayerForLandingStream(stream) {
  if (!landingStreamInfo) {
    const extraContent = stream.extraContent || {};
    landingStreamInfo = {
      "Landing Stream Lookup": stream.lookup,
      "Landing Stream Type": stream.type,
      "Landing Stream Display Name": stream.displayName,
      "Landing Stream Query Param Override": stream.override,
      "Landing Stream After Permalink": extraContent.slug,
      "Landing Stream Type After Permalink": extraContent.__typename
        ? extraContent.__typename.toLowerCase()
        : undefined,
    };
    dataLayer.push(landingStreamInfo);
  }
}

export function getDataLayerForStream(stream) {
  const extraContent = stream.extraContent || {};
  return {
    "Stream Lookup": stream.lookup,
    "Stream Type": stream.type,
    "Stream Display Name": stream.displayName,
    "Stream Query Param Override": stream.override,
    "Stream After Permalink": extraContent.slug,
    "Stream Type After Permalink": extraContent.__typename
      ? extraContent.__typename.toLowerCase()
      : undefined,
  };
}

export function getDataLayerForCard({ edge, position }) {
  const story = edge.node;
  const { featured } = edge;

  switch (edge.node.__typename) {
    case "Content":
      return {
        Headline: story.headline,
        Authors:
          story.authors &&
          story.authors.map(author => author.display_name).join("|"),
        Editors:
          story.editors &&
          story.editors.map(editor => editor.display_name).join("|"),
        "Published Date": story.published_date,
        "Primary Section": story.primary_section && story.primary_section.name,
        Sections:
          story.sections &&
          story.sections.map(section => section.name).join("|"),
        "Primary Tag": story.primary_tag && story.primary_tag.name,
        Tags: story.tags && story.tags.map(tag => tag.name).join("|"),
        "Post ID": story.id,
        Permalink: story.permalink,
        Card: true,
        "Card Count": 1,
        Rubric: story.rubric && story.rubric.name,
        Featured: featured,
        Position: position + 1,
        "Word Count Total": story.wordcount,
        "Word Count Above Fold": story.before_read_more_wordcount,
        "Word Count Below Fold": story.read_more_wordcount,
        "Card Type": story.__typename,
        "Contains CTA": story.promotion ? true : false,
        ...getDataLayerForPromo(story.promotion),
      };
    default:
      return {
        ...resetContentValues(),
        Card: true,
        "Card Count": 1,
        "Card Type": edge.node.__typename,
        Position: position + 1,
        "Post ID": edge.node.id,
      };
  }
}

export function streamItemDataLayerEvent({ stream, edge, position }, event) {
  dataLayer.push({
    ...getDataLayerForStream(stream),
    ...getDataLayerForCard({ edge, position }),
    event,
  });
}

export function getDataLayerForPromo(promo) {
  if (!promo) {
    return {
      ...resetPromoValues(),
    };
  }
  return {
    "Promo Header": promo.header,
    "Promo Image": promo.image,
    "Promo Title": promo.title,
    "Promo Content": promo.content,
    "Promo Link": promo.link,
    "Promo List": promo.list,
    "Promo ID": promo.id,
  };
}

export function promoInViewDataLayerEvent(category, promo) {
  dataLayer.push({
    ...getDataLayerForPromo(promo),
    "event category": category,
    event: GTM_EVENTS.IN_VIEW,
  });
}

export function optimizeActivate() {
  dataLayer.push({
    event: "optimize.activate",
  });
}
